export default function Logo({ size = 34 }) {
  return (
    <img
      src="/logo-mark.png"
      alt="No To Meth — a heart of chain links with one link breaking"
      data-testid="logo-mark"
      className="object-contain"
      style={{ height: size, width: "auto" }}
    />
  );
}
